export enum TAB_PREVIEW_ENUMS {
  LIST = "list",
  TABLE = "table",
}
